import { render, staticRenderFns } from "./touch.vue?vue&type=template&id=a27ad7c6&scoped=true&"
import script from "./touch.vue?vue&type=script&lang=js&"
export * from "./touch.vue?vue&type=script&lang=js&"
import style0 from "./touch.vue?vue&type=style&index=0&id=a27ad7c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27ad7c6",
  null
  
)

export default component.exports